// @ts-nocheck
import { useEffect } from "react";

declare global {
  interface Window {
    dataLayer: Array<unknown>;

    fbq: (
      action: string,
      value: string,
      options?: Record<string, unknown>,
    ) => void;

    gtag: (...args: Array<unknown>) => void;
  }
}

function loadGoogleScripts() {
  if (!import.meta.env.VITE_GTM_ID && !import.meta.env.VITE_GTAG_ID) {
    return;
  }

  // Google Tag Manager
  if (import.meta.env.VITE_GTM_ID) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    const gtmScript = document.createElement("script");
    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${import.meta.env.VITE_GTM_ID}`;
    document.head.appendChild(gtmScript);
  }

  // Google Analytics
  if (import.meta.env.VITE_GTAG_ID) {
    const gtagScript = document.createElement("script");
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${import.meta.env.VITE_GTAG_ID}`;
    document.head.appendChild(gtagScript);

    gtagScript.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag(...args: Array<unknown>) {
        window.dataLayer.push(args);
      }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", import.meta.env.VITE_GTAG_ID);
    };
  }
}

function loadMetaScripts() {
  if (!import.meta.env.VITE_META_PIXEL_ID) {
    return;
  }

  // Meta Pixel
  const fbScript = document.createElement("script");
  fbScript.async = true;
  fbScript.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(fbScript);

  fbScript.onload = () => {
    window.fbq =
      window.fbq ||
      ((...args: Array<unknown>) => {
        window.fbq.callMethod
          ? window.fbq.callMethod.apply(window.fbq, args)
          : window.fbq.queue.push(args);
      });
    if (!window._fbq) window._fbq = window.fbq;
    window.fbq.push = window.fbq;
    window.fbq.loaded = true;
    window.fbq.version = "2.0";
    window.fbq.queue = [];
    window.fbq("init", import.meta.env.VITE_META_PIXEL_ID);
    window.fbq("track", "PageView");
  };

  // NoScript for Meta Pixel
  const noscript = document.createElement("noscript");
  noscript.innerHTML = `<img height="1" width="1" src="https://www.facebook.com/tr?id=${import.meta.env.VITE_META_PIXEL_ID}&ev=PageView&noscript=1" />`;
  document.body.appendChild(noscript);
}

/**
 * Should not be needed as it's already imported by GTM
 */
function _loadAxeptioScripts() {
  // Axeptio
  window.axeptioSettings = {
    clientId: import.meta.env.VITE_GTM_CLIENT_ID,
    cookiesVersion: "winamp - start -en-EU",
    googleConsentMode: {
      default: {
        analytics_storage: "denied",
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        wait_for_update: 500,
      },
    },
  };

  const axeptioScript = document.createElement("script");
  axeptioScript.async = true;
  axeptioScript.src = "//static.axept.io/sdk.js";
  document.head.appendChild(axeptioScript);
}

export function TrackingScripts() {
  useEffect(() => {
    const isProduction = window.location.href.includes(
      "https://account-web.winamp.io",
    );
    if (!isProduction) return;

    loadGoogleScripts();

    loadMetaScripts();
  }, []);

  return null;
}
